module.exports = __webpack_public_path__ + "static/media/nextgen_background.6d986662.jpg";